import PrintModeModal from '../../Components/PrintModeModal';
import { SET_PRINT_MODE, RESET_PRINT_MODE, PRINT_MODE_MODAL_STATUS } from './PrintModeType';

const initialState = {
    selectedMode: 'Native',
    PrintModeModalStatus: false,
    sitaFlexLocationId: 'A-JAF-JAF1WLB007' // 'A-JAF-JAF1WLB006' // default to SITA flex suitcase for staging
};

const printModeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRINT_MODE:
            return {
                ...state,
                selectedMode: action.selectedMode
            };

        case RESET_PRINT_MODE:
            return {
                ...state,
                selectedMode: 'Native' // Reset back to default Native
            };
        
        case PRINT_MODE_MODAL_STATUS:
            return {
                ...state,
                PrintModeModalStatus: action.PrintModeModalStatus
            };

        default:
            return state;
    }
};

export default printModeReducer;
